<template>
  <v-card>
    <v-card-title class="accent--text">{{ InfoData.DO_NAZ }}</v-card-title>
    <v-card-text class="py-1 px-2 font-italic"><span class="primary--text">Inventární číslo: </span>{{ InfoData.DO_KOD }}</v-card-text>
    <v-card-text class="py-1 px-2">{{ InfoData.DO_TEMA }}</v-card-text>
    <v-card-text class="py-1 px-2">
      <table>
        <tr>
          <td class="primary--text">Plocha objektu (ha):</td>
          <td>{{ InfoData.DO_PLOCHA }}</td>
        </tr>
        <tr>
          <td class="primary--text">Lesní oblast:</td>
          <td>{{ InfoData.PLOs }}</td>
        </tr>
        <tr>
          <td class="primary--text">Hospodářské soubory:</td>
          <td>{{ InfoData.CHSs }}</td>
        </tr>
        <tr>
          <td class="primary--text">Soubory lesních typů:</td>
          <td>{{ InfoData.SLTs }}</td>
        </tr>
        <tr>
          <td class="primary--text">Zastoupené dřeviny:</td>
          <td>{{ InfoData.DRs }}</td>
        </tr>
      </table>
    </v-card-text>



    <div class="d-flex flex-row pa-2">
      <v-tooltip top v-for="item in InfoData_Docs" :key="item.uri">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" :href="item.uri" target="DemoDoc" class="mx-2">
            <v-icon large color="">mdi-clipboard-text</v-icon>
          </v-btn>
        </template>
        <span>{{ item.nazev }}</span>
      </v-tooltip>
    </div>

  </v-card>
</template>

<script>
export default {

  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // data 
    InfoData: Object,

  },

  computed: {
    InfoData_Docs: function () {
      if (this.InfoData.DOC == null) { return [] } else { return JSON.parse(this.InfoData.DOC) }
    },

  },


}


</script>
